var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTdhDisabledLightMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.987 0C9.039-.005 9.886.85 9.89 1.903a1.907 1.907 0 0 1-1.9 1.911 4.18 4.18 0 0 1 4.198 4.166c.012 2.312-1.867 4.194-4.18 4.206a1.9 1.9 0 0 0-1.9 1.911A1.9 1.9 0 0 0 8.027 16c4.417-.023 7.995-3.62 7.973-8.037C15.977 3.547 12.404-.022 7.987 0Z",
  fill: "#6F6F6F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M8.027 16a1.914 1.914 0 0 1-1.918-1.903c0-1.052.848-1.911 1.9-1.911-2.312 0-4.198-1.875-4.198-4.187a4.179 4.179 0 0 1 4.18-4.185c1.051 0 1.9-.834 1.9-1.911A1.887 1.887 0 0 0 7.987 0C3.569 0 0 3.58 0 7.996 0 12.413 3.61 16 8.027 16Z",
  fill: "#6F6F6F"
})));
export default SvgTdhDisabledLightMode;